import Vue from 'vue';
import VueAxios from 'vue-axios';
import VueMoment from 'vue-moment';
import { get } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEuroSign } from '@fortawesome/free-solid-svg-icons';
import VueCurrencyFilter from 'vue-currency-filter';
import VueTextareaAutosize from 'vue-textarea-autosize';
import VueUploadComponent from 'vue-upload-component';
import VTooltip from 'v-tooltip';
import Tabs from 'vue-tabs-component';
import App from './App.vue';
import router from './router';
import store from './store/store';
import axios from './backend/axios';
import i18n from './i18n';
import { SET_ALERT } from './store/mutation-types';

library.add(faEuroSign);
Vue.use(VueAxios, axios);
Vue.use(VueTextareaAutosize);
Vue.use(VueMoment);
Vue.use(Tabs);
Vue.use(VTooltip);
Vue.component('file-upload', VueUploadComponent);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.use(
  VueCurrencyFilter,
  {
    symbol: '€',
    thousandsSeparator: ' ',
    fractionCount: 0,
    fractionSeparator: ',',
    symbolPosition: 'end',
    symbolSpacing: false,
  },
);

Vue.config.productionTip = false;

Vue.axios.interceptors.response.use((response) => {
  store.commit(SET_ALERT, null);
  return response;
}, (error) => {
  if (!error.response || error.response.status === 401) {
    delete localStorage.authorization;
    if (!get(router, 'currentRoute.meta.public')) {
      router.push(`/?redirect=${router.currentRoute.path}`);
    }
    if (error.message === 'Network Error') {
      store.commit(SET_ALERT, 'Le serveur est indisponible');
    } else {
      store.commit(SET_ALERT, null);
    }
  }
  return Promise.reject(error);
});

Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted(el) {
    // Focus the element
    el.focus();
  },
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
